// store/slices/scenarios.ts — the scenario catalogue.
//
// Static for the duration of a session; populated from sync:initial.scenarios.
// Used by the Dashboard to label per-scenario breakdowns with display names.

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AdminScenario } from "../types";

interface ScenariosState {
  list: AdminScenario[];
}

const initialState: ScenariosState = { list: [] };

const scenarios = createSlice({
  name: "scenarios",
  initialState,
  reducers: {
    set(state, action: PayloadAction<AdminScenario[]>) {
      state.list = action.payload;
    },
    clear(state) {
      state.list = [];
    },
  },
});

export default scenarios;
